"use client";

import { useTranslation } from "react-i18next";
import { ChartProductUsageTotalValueProps } from "../types";
import {
  extractCurrencySymbol,
  extractValue,
} from "@/core/utils/extract-currency";

export function ChartProductUsageTotalValue({
  valueLabel,
}: ChartProductUsageTotalValueProps) {
  const [translate] = useTranslation(["dashboard"]);

  return (
    <div className="text-center flex flex-col gap-2 px-6">
      <div className="text-sm text-darkgray-900 font-normal">
        {translate("dashboard-chart-product-usage-total-value-title")}
      </div>
      <div className="font-normal text-darkgray-900">
        <span className="text-2xl font-normal mr-2">
          {extractCurrencySymbol(valueLabel)}
        </span>
        <span className="text-[32px] font-normal">
          {extractValue(valueLabel)}
        </span>
      </div>
    </div>
  );
}
